import { atom } from "jotai";

export const confirmState = atom({
  isOpen: false,
  msg: "",
  onConfirm: () => {},
  onCancel: () => {},
});

export const aiConfirmState = atom({
  isOpen: false,
  msg: "",
  checked: true,
  handleChange: () => {},
  onConfirm: () => {},
  onCancel: () => {},
  callPrivacy: () => {},
});

export const defaultInterceptorState = {
  authUrls: [
    "/home-update",
    "/reels-category-upsert",
    "/reels-upsert",
    "/product-upsert",
    "/detail-category-upsert",
    "/detail-list-upsert",
  ],
  load: false,
};

export const interceptorState = atom(defaultInterceptorState);

export const defaultLoadingState = {
  isLoad: false,
};

export const loadingState = atom(defaultLoadingState);

export const defaultDimLoadingState = {
  isLoad: true,
};

export const dimLoadingState = atom(defaultDimLoadingState);
